import type { ReactNode } from "react";

import { Button } from "../../Button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../Select";

export interface IMultiSelectFilter {
  type: "multiSelect";
  values: string[];
}

export interface IFilterOption {
  value: string;
  label: ReactNode;
}

interface IMultiSelectFilterInputProps {
  value: IMultiSelectFilter | undefined;
  onChange: (value: IMultiSelectFilter | undefined) => void;
  options: IFilterOption[];
  placeholder?: string;
}

export function MultiSelectFilterInput({
  value,
  onChange,
  options,
  placeholder = "Select options…",
}: IMultiSelectFilterInputProps) {
  const handleChange = (selected: string[]) => {
    if (selected.length === 0) {
      onChange(undefined);
    } else {
      onChange({ type: "multiSelect", values: selected });
    }
  };

  return (
    <Select
      multiple
      searchable
      value={value?.values}
      onValueChange={(next: string[]) => handleChange(next)}
    >
      <SelectTrigger>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="max-w-[400px] w-auto">
        <div className="flex items-center justify-between gap-2 border-b border-gray-200 px-2 py-1.5">
          <Button
            type="button"
            variant="link"
            size="sm"
            className="h-auto p-0 text-sm"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => handleChange(options.map((o) => o.value))}
          >
            Select all
          </Button>
          <Button
            type="button"
            variant="link"
            size="sm"
            className="h-auto p-0 text-sm"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => handleChange([])}
          >
            Clear all
          </Button>
        </div>
        {options.map((o) => (
          <SelectItem key={o.value} value={o.value}>
            {o.label}
          </SelectItem>
        ))}
        {/* more items */}
      </SelectContent>
    </Select>
  );
}
